import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import './ExperiencePage.css'; 
function Yearsexp() {
  return (
    <div>
      <section className="section section-sm bg-default">
        <div className="container">
          <div className="row row-30 row-xl-24 justify-content-center align-items-center align-items-lg-start text-left">
            <div className="col-md-6 col-lg-5 col-xl-4 text-center">
                
            <div className="big-number-container">
                <div className="big-number">10</div>
            </div>


            </div>
            <div className="col-sm-8 col-md-6 col-lg-5 col-xl-4">
              <div className="text-width-extra-small offset-top-lg-24 wow fadeInUp">
                <h3 className="title-decoration-lines-left">Years of Experience</h3>
                <p className="text-gray-500">RatherApp is a team of highly experienced app designers and developers creating unique software for you.</p><a className="button button-secondary button-pipaluk" href="#">Get in touch</a>
              </div>
            </div>

            <Container className="stats-section my-5">
                <Row className="g-4">
        {/* First Stat */}
        <Col md={4}>
          <div className="stat-item">
            <div className="stat-number">2k</div>
            <div className="stat-text">
              <div className="stat-value">4.0</div>
              <div className="stat-label">APPS DEVELOPED CONSULTANTS</div>
            </div>
          </div>
        </Col>

        {/* Second Stat */}
        <Col md={4}>
          <div className="stat-item">
            <div className="stat-number">12</div>
            <div className="stat-text">
              <div className="stat-value">16.0</div>
              <div className="stat-label">AWARDS WON EMPLOYEES</div>
            </div>
          </div>
        </Col>
        <Col md={4}>
          <div className="stat-item">
            <div className="stat-number">12</div>
            <div className="stat-text">
              <div className="stat-value">16.0</div>
              <div className="stat-label">AWARDS WON EMPLOYEES</div>
            </div>
          </div>
        </Col>

        {/* Add more stats as needed */}
      </Row>
    </Container>

            {/* <div className="col-sm-10 col-md-8 col-lg-6 col-xl-4 wow fadeInRight" data-wow-delay=".1s">
              <div className="row justify-content-center border-2-column offset-top-xl-26">
                <div className="col-9 col-sm-6">
                  <div className="counter-amy">
                    <div className="counter-amy-number"><span className="counter">2</span><span className="symbol">k</span>
                    </div>
                    <h6 className="counter-amy-title">apps developed</h6>
                  </div>
                </div>
                <div className="col-9 col-sm-6">
                  <div className="counter-amy">
                    <div className="counter-amy-number"><span className="counter">40</span>
                    </div>
                    <h6 className="counter-amy-title">Consultants</h6>
                  </div>
                </div>
                <div className="col-9 col-sm-6">
                  <div className="counter-amy">
                    <div className="counter-amy-number"><span className="counter">12</span>
                    </div>
                    <h6 className="counter-amy-title">Awards won</h6>
                  </div>
                </div>
                <div className="col-9 col-sm-6">
                  <div className="counter-amy">
                    <div className="counter-amy-number"><span className="counter">160</span>
                    </div>
                    <h6 className="counter-amy-title">Employees</h6>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-lg-6 col-xl-12 align-self-center">
              <div className="row row-30 justify-content-center">
                <div className="col-sm-6 col-md-5 col-lg-6 col-xl-3 wow fadeInLeft"><a className="clients-classNameic" href="#"><img src="images/clients-9-270x117.png" alt="" width="270" height="117"/></a></div>
                <div className="col-sm-6 col-md-5 col-lg-6 col-xl-3 wow fadeInLeft" data-wow-delay=".1s"><a className="clients-classNameic" href="#"><img src="images/clients-10-270x117.png" alt="" width="270" height="117"/></a></div>
                <div className="col-sm-6 col-md-5 col-lg-6 col-xl-3 wow fadeInLeft" data-wow-delay=".2s"><a className="clients-classNameic" href="#"><img src="images/clients-3-270x117.png" alt="" width="270" height="117"/></a></div>
                <div className="col-sm-6 col-md-5 col-lg-6 col-xl-3 wow fadeInLeft" data-wow-delay=".3s"><a className="clients-classNameic" href="#"><img src="images/clients-11-270x117.png" alt="" width="270" height="117"/></a></div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      

    </div>
  )
}

export default Yearsexp
